module.exports = __webpack_public_path__ + "img/img_beneficio1.ab6b0167.png";